var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22601",
    "data-name": "Group 22601",
    transform: "translate(-27 -487)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7599",
    "data-name": "Rectangle 7599",
    width: 20,
    height: 20,
    transform: "translate(27 487)",
    fill: "#9ff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22501",
    "data-name": "Group 22501",
    transform: "translate(27.655 487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101763",
    "data-name": "Path 101763",
    d: "M-109.261-252.124l.02.035a1.2,1.2,0,0,0,.923.562h0v-.965l-.566-.258Z",
    transform: "translate(117.451 255.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101764",
    "data-name": "Path 101764",
    d: "M-94.536-252.492v.965a1.2,1.2,0,0,0,.923-.562l.02-.035-.376-.626Z",
    transform: "translate(104.094 255.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101765",
    "data-name": "Path 101765",
    d: "M-109.261-252.124l.02.035a1.2,1.2,0,0,0,.923.562h0v-.965l-.566-.258Z",
    transform: "translate(117.451 255.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101766",
    "data-name": "Path 101766",
    d: "M-122.3-160.95v5.639H-123.9l0-.348.037-5.291-.172,5.311-.014.447h1.866l-.009-.467Z",
    transform: "translate(130.913 172.858)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101767",
    "data-name": "Path 101767",
    d: "M-93.613-252.089l.02-.035-.376-.626-.566.258v.965A1.2,1.2,0,0,0-93.613-252.089Z",
    transform: "translate(104.094 255.09)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101768",
    "data-name": "Path 101768",
    d: "M-92.961-155.659v-5.291l-.1,5.291-.009.467h1.866l-.015-.467-.171-5.291.037,5.291,0,.348h-1.606Z",
    transform: "translate(102.835 172.858)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101769",
    "data-name": "Path 101769",
    d: "M-164.687-155.57l-.353.76.353,3.421.353-3.421Z",
    transform: "translate(168.042 167.42)",
    fill: "#9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101770",
    "data-name": "Path 101770",
    d: "M-36.37-155.57l-.353.76.353,3.421.353-3.421Z",
    transform: "translate(51.627 167.42)",
    fill: "#9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101771",
    "data-name": "Path 101771",
    d: "M-107.532-218.614v-1.042h-.872Z",
    transform: "translate(116.669 225.322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101772",
    "data-name": "Path 101772",
    d: "M-109.261-233.366h.942v-.927h-.573Z",
    transform: "translate(117.451 238.608)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101773",
    "data-name": "Path 101773",
    d: "M-93.963-234.294h-.573v.927h.942Z",
    transform: "translate(104.094 238.608)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101774",
    "data-name": "Path 101774",
    d: "M-94.536-219.656v1.042l.872-1.042Z",
    transform: "translate(104.089 225.322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101775",
    "data-name": "Path 101775",
    d: "M-79.728-91.7l-.4-.29v.519h-1.188l.136,1.248c1.663.167,1.939-.2,1.939-.2a5.948,5.948,0,0,0-.38-1.019C-79.637-91.48-79.678-91.578-79.728-91.7Z",
    transform: "translate(92.194 109.583)",
    fill: "#9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101776",
    "data-name": "Path 101776",
    d: "M-136.1-91.58v-.529l-.17.184a4.345,4.345,0,0,0-.245.374,5.947,5.947,0,0,0-.38,1.019s.277.368,1.948.2l.135-1.247Z",
    transform: "translate(142.566 109.692)",
    fill: "#9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101777",
    "data-name": "Path 101777",
    d: "M-110.937-85.693h-1.181c-.059.358-.145,1.42-.145,1.42v.059a1.618,1.618,0,0,0,1.153.4s.1.009.145.007.145-.007.145-.007a1.618,1.618,0,0,0,1.153-.4v-.171c-.024-.283-.088-1.021-.136-1.308Z",
    transform: "translate(120.278 103.805)",
    fill: "#9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101778",
    "data-name": "Path 101778",
    d: "M-179.9-268.552l-5.627-5.68-1.448-5.334-1.086-1.573-1.086,1.573-1.448,5.334-5.627,5.68-1.185,2.107.395.613h.329l.658-.293,1.68-.84-.008,0-.2-1.707.526-1.053.531,1.05-.189,1.68-.005.012,2.132.731a65.161,65.161,0,0,1,1.966-10.128,75.912,75.912,0,0,0-1.843,10.134l-.083.045-3.043,2.521,1.363.892,1.885-1.117-.207.69.4-.269.312-.211v.587h5.3v-.587l.592.316.306.164-.207-.69,1.885,1.117,1.363-.892-3.015-2.5v0l-.132-.071a75.912,75.912,0,0,0-1.843-10.134,65.2,65.2,0,0,1,1.966,10.135l2.086-.715-.007,0-.2-1.707.526-1.053.531,1.05-.189,1.68,0,0,1.741.87.658.293h.329l.395-.613Zm-10.733,5,.016-.5.192-5.961-.041,5.938,0,.391h1.8v-6.329l.116,5.938.01.524Zm2.421-10.725-.976-1.169h.976Zm0-1.483h-1.055l.413-1.041h.642Zm0-1.376h0a1.345,1.345,0,0,1-1.033-.63l-.022-.04.421-.7.634.289Zm0-1.34-.563-.257.563-1.083Zm.3-1.34.563,1.083-.563.257Zm0,1.6.634-.289.421.7-.022.04a1.346,1.346,0,0,1-1.033.63Zm0,1.418h.642l.413,1.041h-1.055Zm0,1.354h.976l-.976,1.169Zm2.057,11.37-.041-5.938.192,5.938.017.524h-2.089l.01-.524.116-5.938v6.329h1.8Z",
    transform: "translate(197.41 281.139)",
    fill: "#9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.4ec4dcc4430d8faad979c59393d1da76.svg";
export { ForwardRef as ReactComponent };